module.exports = __webpack_public_path__ + "img/alert.b63b1104.png";